import { getUser } from "@/api/user";
import Vue from "vue";

const state = {
  data: {},
};

const mutations = {
  SET_USER(state, data) {
    state.data = data;
  },
};

const actions = {
  async getUser({ commit }, payload) {
    try {
      const response = await getUser(payload);
      if (response && response.code === 200 && response.data) {
        commit("SET_USER", response.data);
        return response;
      } else {
        throw response.message;
      }
    } catch (e) {
      Vue.$toast.error(e, {
        duration: 0,
      });
    }
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
